
import * as XLSX from "xlsx";
import { getAdherentCompetitionCategories } from "./suiviCompetitionsUtils";

/**
 * Normalise le sexe de l'adhérent au format M ou F.
 */
function getSexe(adherent) {
  const value = String(
    adherent?.sexe ?? adherent?.genre ?? ""
  )
    .trim()
    .toUpperCase();

  if (["M", "H", "MASCULIN", "HOMME"].includes(value)) return "M";
  if (["F", "FEMININ", "FÉMININ", "FEMME"].includes(value)) return "F";

  return "";
}

/**
 * Construit l'épreuve, par exemple : M : -38 Kg.
 */
function getEpreuve(adherent) {
  const categories = getAdherentCompetitionCategories(adherent);

  // À adapter si la propriété de catégorie de poids
  // porte un autre nom dans suiviCompetitionsUtils.
  const rawWeight =
    categories?.weightCategory ??
    categories?.categoriePoids ??
    adherent?.categorie_poids ??
    adherent?.cat_poids ??
    "";

  const sexe = getSexe(adherent);

  const weight = String(rawWeight)
    .trim()
    .replace(/\s*kg\s*/gi, "")
    .replace(/\s+/g, "");

  if (!sexe || !weight) return "";

  return `${sexe} : ${weight} Kg`;
}

/**
 * Exporte les inscrits d'une compétition au format Excel.
 */
export function exportCompetitionExcel(event, registrants = []) {
  if (!registrants.length) {
    throw new Error("Aucun inscrit à exporter.");
  }

  const rows = registrants.map((adherent) => ({
    "N° Licence": String(adherent?.licence_number ?? "").trim(),
    Épreuve: getEpreuve(adherent),
  }));

  // Signale les données manquantes plutôt que produire
  // un fichier incomplet ou incorrect.
  const invalidRows = rows.filter(
    (row) => !row["N° Licence"] || !row["Épreuve"]
  );

  if (invalidRows.length > 0) {
    throw new Error(
      `${invalidRows.length} inscrit(s) ont une licence ou une épreuve manquante.`
    );
  }

  const worksheet = XLSX.utils.json_to_sheet(rows, {
    header: ["N° Licence", "Épreuve"],
  });

  worksheet["!cols"] = [
    { wch: 22 },
    { wch: 22 },
  ];

  // Force la colonne licence au format texte.
  for (let row = 2; row <= rows.length + 1; row++) {
    const cell = worksheet[`A${row}`];

    if (cell) {
      cell.t = "s";
      cell.z = "@";
    }
  }

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Inscrits"
  );

  const eventName = String(event?.titre || "competition")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, 70);

  const filename = `Inscriptions_${eventName}.xlsx`;

  XLSX.writeFile(workbook, filename);
}
